import React, { useState } from 'react';
import RPAInfo from '../components/RPAinfo'
import '../css/styles.css'
import '../css/general.css'
import '../css/queries.css'

function Contact() {
    const [responseMessage, setResponseMessage] = useState('');
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        phone: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setResponseMessage('');
        setError('');
        try {
            const response = await fetch('https://api.datascalp.com/apiv1/contact-us', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                await response.json();
                setResponseMessage('Contact email sent successfully!');
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    company: '',
                    phone: '',
                    subject: '',
                    message: ''
                }); // Reset form
            } else {
                const errorData = await response.json();
                setError(` ${errorData.message || 'Unknown error'}`);
            }
        } catch (err) {
            setError('An error occurred while submitting the form. Please try again.');
            console.error(err);
        }
    };
    return (
        <div className="section-report-incident">
            <div className="container incident-flex">
                {/* RPA info */}
                <RPAInfo />
                <div className="rpa-info-container">
                    <h1 className="contact-title">Drive Operational Excellence and Sustainable Growth with DataScalp</h1>
                    <p className="contact-pragraph">Connect with our team to explore how DataScalp’s performance analytics and eco-friendly insights can help your organization to improve efficiency,
                        enhance customer trust, and lead in sustainability.</p>

                    <div className="contact-page mt-3">
                        <div className="contact-container">
                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="form-row">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="firstName"
                                            placeholder="First Name"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="lastName"
                                            placeholder="Last Name"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="company"
                                            placeholder="Company"
                                            value={formData.company}
                                            onChange={handleChange}
                                            className="form-input"
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <input
                                            type="tel"
                                            name="phone"
                                            placeholder="Phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="form-input"
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <input
                                            type="text"
                                            name="subject"
                                            placeholder="Subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            className="form-input"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <textarea
                                            name="message"
                                            placeholder="Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            className="form-textarea"
                                            rows="6"
                                            required
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <button type="submit" className="submit-btn">
                                        Send Message
                                    </button>
                                    {responseMessage && <p style={{ color: 'green', fontSize: '16px' }}>{responseMessage}</p>}
                                    {error && <p style={{ color: 'red', fontSize: '16px' }}>{error}</p>}
                                </div>
                            </form>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Contact